import Admin, { hasRole, Role } from '@/models/Admin'
import Station from '@/models/Station'

export default class StationPolicy {
	viewAny(_admin: Admin): boolean {
		return true
	}

	view(admin: Admin, station: Station) {
		return true
	}

	create(admin: Admin) {
		return hasRole(admin, Role.SUPER_ADMIN)
	}

	update(admin: Admin, station: Station) {
		return hasRole(admin, Role.SUPER_ADMIN)
	}

	restore(admin: Admin, station: Station) {
		return hasRole(admin, Role.SUPER_ADMIN)
	}

	delete(admin: Admin, station: Station) {
		return hasRole(admin, Role.SUPER_ADMIN)
	}

	forceDelete(_admin: Admin, _station: Station) {
		return false
	}
}
